import React from 'react';

// Components
import { IncomingInvitationPopup } from './containers/IncomingInvitePopup';
import { InvitationStatusSticker } from './components/InvitationStatusSticker';

// HOCS
import { ShowInvitationStatusHoc } from './hocs/showInvitationStatusHOC';

const IncomingInvitationService = () => (
  <>
    <ShowInvitationStatusHoc>
      <InvitationStatusSticker />
    </ShowInvitationStatusHoc>
    <IncomingInvitationPopup />
  </>
);

export { IncomingInvitationService };
